import ChosenThemeActionContext from '@/contexts/ChosenThemeActionContext';
import ChosenThemeContext from '@/contexts/styles/ChosenThemeContext';
import ThemeName from '@/types/styles/ThemeName';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC, PropsWithChildren } from 'react';
import { useLocalStorage } from 'react-use';

export interface IChosenThemeContextProps {
    override?: ThemeName
}

export const ChosenThemeProvider: FC<PropsWithChildren<IChosenThemeContextProps>> = ({ override, children }) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
    const [theme, setTheme] = useLocalStorage<ThemeName>('theme', prefersDarkMode ? 'dark' : 'light')

    //const [theme, setTheme] = useState<ThemeName>('dark');

    const data = (
        <ChosenThemeContext.Provider value={override ?? theme}>
            {children}
        </ChosenThemeContext.Provider>
    )

    if (override) {
        return data;
    }

    return (
        <ChosenThemeActionContext.Provider value={setTheme}>
            {data}
        </ChosenThemeActionContext.Provider>
    );
}

export default ChosenThemeProvider;